import React, { useState } from 'react'
import Form from '@hashicorp/react-components/src/components/marketo-form'
import type { MarketoFormAPIResponse } from '@hashicorp/react-components/src/components/marketo-form/types'
import s from './style.module.css'

interface Props {
	product: string[]
	title: string
	webinarId?: string
	marketoForm: MarketoFormAPIResponse
	onSubmitSuccess: () => void
}

export default function GatedWebinarMarketoForm({
	product,
	title,
	webinarId,
	marketoForm,
	onSubmitSuccess,
}: Props) {
	const [globalError, setGlobalError] = useState(null)

	return (
		<section className={s.container}>
			<h4 className={s.heading}>Watch the recorded webinar</h4>
			<Form
				{...marketoForm}
				initialValues={
					webinarId ? { registeredWebinarID: webinarId } : undefined
				}
				onSubmitSuccess={() => {
					if (window && window.analytics) {
						window.analytics.track('Webinar Signed Up', {
							...(product?.length && { product: product[0] }),
							title: title,
							webinar_id: webinarId,
							sales_contact_requested: false,
						})
					}

					onSubmitSuccess()
				}}
				onSubmitError={() => {
					setGlobalError(
						'Unfortunately something went wrong. Please try again later.'
					)
				}}
			/>
			{globalError && (
				<div className="global-error g-type-body-small error">
					{globalError}
				</div>
			)}
		</section>
	)
}
